function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCssInJs } from "../../../../hooks";
import { Input } from 'antd';
import cls from 'classnames';
import { useTaskList } from "../../TaskListStore";
import { FILTER_MAP } from "../../constants";
import { Tabs } from "../Tabs";
import { getTaskListFilterHeaderStyle } from "./styles";
import PageTitle from "../../../../components/Layout/PageTitle";
import { ReactComponent as SearchSvg } from "../../../../assets/svg/search.svg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Search = Input.Search;
export default function FilterHeader(props) {
  var onModalOpen = props.onModalOpen;
  var prefix = 'tasklist-filter-header';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getTaskListFilterHeaderStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var _useTaskList = useTaskList(),
    _useTaskList2 = _slicedToArray(_useTaskList, 2),
    snap = _useTaskList2[0],
    state = _useTaskList2[1];
  var onSearch = function onSearch(value, _e, info) {
    // console.log(info?.source, value)
    // if (value) {
    //   state.flowOrderName = value
    // }
  };
  var segmentedOptions = Object.values(FILTER_MAP).map(function (item) {
    return {
      label: item.text,
      value: item.value
    };
  });
  function getOS() {
    var userAgent = navigator.userAgent;
    if (/windows/i.test(userAgent)) {
      return 'Windows';
    } else if (/macintosh|mac os x/i.test(userAgent)) {
      return 'Mac';
    } else {
      return 'Unknown';
    }
  }
  var OSName = getOS();
  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: cls(prefix, hashId),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "headerContent",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        children: "\u5F85\u529E\u4E8B\u9879"
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Search, {
          placeholder: OSName === 'Windows' ? '搜索 (Ctrl+K)' : '搜索 (command+K)',
          allowClear: true,
          onSearch: onSearch,
          enterButton: /*#__PURE__*/_jsx(SearchSvg, {}),
          onClick: function onClick() {
            onModalOpen(true);
          },
          className: "searchInput"
        })
      })]
    }), /*#__PURE__*/_jsx(Tabs, {
      size: "large",
      options: segmentedOptions,
      value: state.todoType,
      onChange: function onChange(value) {
        state.todoType = value;
      }
    })]
  }));
}